import { useEffect, useState } from "react";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose, MdEdit } from "react-icons/md";
import { packingEntryAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import PackingForm from "./PackingForm";
import Button from "../../common/Button";
import { IoCloseSharp } from "react-icons/io5";
import { IoIosSave } from "react-icons/io";

const Packing = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackingData, setSelectedPackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isPackingData, setisPackingData] = useState([]);
  const [isAgingDoneData, setIsAgingDoneData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [formData, setFormData] = useState({
    bundle_No: null,
    packing_Date: today,
    order_No: "",
    batch_Id: "",
    die_Id: "",
    casting_No: "",
    dieNumber: "",
    cut_Length: "",
    wt_12_FT: "",
    wt_Cut_Length: "",
    pcs: "",
    total_Weight: "",
    series_Name: "",
    remark: "",
    // bundle_Pcs: "",
    // bundle_Weight: "",
    unit_Conv_Id: "",
    final_CutLength_weight: "",
  });
  const pageSize = 10;
  const [isActiveTab, setIsActiveTab] = useState("aging-done");
  const [selectedAgingNo, setSelectedAgingNo] = useState(null);
  const [adding, setAdding] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [draft, setDraft] = useState({ pcs: "", total_Weight: "" });
  const [editingRow, setEditingRow] = useState(null);

  const fetchPackingData = async () => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllPackingEntry(
        currentPage,
        pageSize
      );

      setisPackingData(res.data || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalRecords || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching sales order master data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPackingData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isPackingData);
    } else {
      const filtered = isPackingData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isPackingData]);

  const handleEdit = async (row) => {
    const bundle_No = row?.bundle_No;
    setEditingKey(bundle_No);
    setDraft({
      pcs: row.pcs ?? "",
      total_Weight: row.total_Weight ?? "",
    });
    try {
      const res = await packingEntryAPI.getById(bundle_No);
      const doc = res?.data ?? res;
      setEditingRow(doc);
    } catch (err) {
      notify("Failed to fetch packing entry details", "error");
    }
  };

  const cancelInlineEdit = () => {
    setEditingKey(null);
    setDraft({ pcs: "", total_Weight: "" });
    setEditingRow(null);
  };

  const buildPayload = () => {
    const src = editingRow ?? {};
    return {
      ...src,
      bundle_No: src.bundle_No,
      order_No: src.order_No,
      die_Id: src.die_Id,
      cut_Length: src.cut_Length,
      packing_Date: src.packing_Date,
      batch_Id: src.batch_Id,
      casting_No: src.casting_No,
      series_Name: src.series_Name,
      remark: src.remark,
      wt_12_FT: src.wT_12_FT ?? src.wt_12_FT ?? 0,
      wt_Cut_Length: src.wT_Cut_Length ?? src.wt_Cut_Length ?? 0,
      // bundle_Pcs: src.bundle_Pcs ?? null,
      // bundle_Weight: src.bundle_Weight ?? null,
      unit_Conv_Id: src.unit_Conv_Id,
      final_CutLength_weight: src.final_CutLength_weight,
      pcs: Number(draft.pcs || 0),
      total_Weight: parseFloat(draft.total_Weight || 0),
    };
  };

  const handleinlineSave = async (row) => {
    try {
      const payload = buildPayload();
      await packingEntryAPI.saveOrUpdate(payload);
      notify("Saved successfully", "success");
      cancelInlineEdit();
      fetchPackingData();
      setIsModelOpen(false);
    } catch (err) {
      notify(err?.response?.data?.message || "Failed to save", "error");
    }
  };

  const handleSave = async (data, id) => {
    try {
      const finalData = {
        bundle_No: data.bundle_No || "0",
        packing_Date: data.packing_Date,
        die_Id: data.die_Id,
        order_No: Number(data.order_No),
        dieNumber: data.dieNumber,
        batch_Id: data.batch_Id,
        casting_No: data.casting_No,
        cut_Length: Number(data.cut_Length),
        wt_12_FT: parseFloat(data.wt_12_FT || 0),
        wt_Cut_Length: parseFloat(data.wt_Cut_Length || 0),
        pcs: Number(data.pcs || 0),
        total_Weight: parseFloat(data.total_Weight || 0),
        series_Name: data.series_Name,
        remark: data.remark,
        // bundle_Pcs: data.bundle_Pcs,
        // bundle_Weight: data.bundle_Weight,
        unit_Conv_Id: data.unit_Conv_Id,
        final_CutLength_weight: data.final_CutLength_weight,
      };

      await packingEntryAPI.saveOrUpdate(finalData);
      notify(id ? "Updated successfully" : "Added successfully", "success");
      fetchPackingData();
      fetchAgingDoneData();
      setIsModelOpen(false);
      setFormData({
        bundle_No: "0",
        packing_Date: today,
        order_No: "",
        dieNumber: "",
        die_Id: "",
        batch_Id: "",
        casting_No: "",
        cut_Length: "",
        wt_12_FT: "",
        wt_Cut_Length: "",
        pcs: "",
        total_Weight: "",
        series_Name: "",
        remark: "",
        // bundle_Pcs: "",
        // bundle_Weight: "",
        unit_Conv_Id: "",
        final_CutLength_weight: "",
      });
      setIsEditing(false);
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    }
  };

  const fetchAgingDoneData = async () => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllAgingDone(currentPage, pageSize);
      setIsAgingDoneData(res.data || []);
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAgingDoneData();
  }, [currentPage]);

  const columns = [
    {
      key: "select",
      label: null,
      render: (_v, row) => {
        const id = Number(row.seq_No);
        const isChecked = Number(selectedAgingNo) === id;
        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              if (e.target.checked) setSelectedAgingNo(id);
              else setSelectedAgingNo(null);
            }}
          />
        );
      },
    },
    { key: "order_No", label: "ORDER NO" },
    { key: "batch_Id", label: "BATCH NO" },
    { key: "dieNumber", label: "DIE NO" },
    { key: "cut_Length", label: "Cut Length" },
    { key: "quantity", label: "Pcs" },
    { key: "pending_Pcs", label: "PENDING PCS" },
    { key: "total_Weight", label: "Total weight" },
  ];

  const handleAddPacking = async () => {
    if (!selectedAgingNo) {
      notify("Please select one Aging-Done row.", "warning");
      return;
    }
    setAdding(true);
    try {
      const resp = await packingEntryAPI.AddToPacking(Number(selectedAgingNo));
      const x = Array.isArray(resp) ? resp[0] : resp;
      const init = {
        bundle_No: "0",
        packing_Date: today,
        order_No: x?.order_No ?? "",
        die_Id: x?.die_Id ?? null,
        dieNumber: x?.dieNumber ?? "",
        cut_Length: x?.cut_Length ?? "",
        batch_Id: x?.batch_Id ?? "",
        casting_No: x?.casting_No ?? "",
        total_Weight: x?.total_Weight ?? "",
        wt_12_FT: "",
        wt_Cut_Length: "",
        pcs: "",
        series_Name: x?.series_Name ?? "",
        remark: "",
        // bundle_Pcs: "",
        // bundle_Weight: "",
        unit_Conv_Id: "",
        final_CutLength_weight: "",
      };
      setSelectedPackingData(init);
      setIsActiveTab("packing");
      setIsModelOpen(true);
      setIsEditing(true);
      setSelectedAgingNo(null);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Packing",
        "error"
      );
    } finally {
      setAdding(false);
    }
  };

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5  mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconColor="text-primary"
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                iconSize="w-5 h-5"
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              >
                <MdClose />
              </Button>
            )}
          </div>
          {isActiveTab === "aging-done" && (
            <Button
              text={
                adding
                  ? "Adding..."
                  : `Add Packing${selectedAgingNo ? " (1)" : ""}`
              }
              className="text-black text-md font-semibold bg-orange rounded-md p-2 disabled:opacity-60"
              onClick={handleAddPacking}
              icon={HiOutlinePlus}
              iconColor="text-black"
              iconSpacing="pr-2"
              disabled={adding || !selectedAgingNo}
            />
          )}
        </div>
        <div className="flex border-b border-gray-200 mb-4">
          <div
            onClick={() => setIsActiveTab("aging-done")}
            className={`mr-8 pb-2 cursor-pointer relative font-semibold ${
              isActiveTab === "aging-done"
                ? "text-primary border-b-2 border-primary"
                : "text-secondary"
            }`}
          >
            Aging Done
          </div>
          <div
            onClick={() => setIsActiveTab("packing")}
            className={`pb-2 cursor-pointer relative font-semibold ${
              isActiveTab === "packing"
                ? "text-primary border-b-2 border-primary"
                : "text-secondary"
            }`}
          >
            Packing Entry
          </div>
        </div>
        {isActiveTab === "aging-done" && (
          <Table
            columns={columns}
            data={isAgingDoneData}
            showActions={false}
            onRowClick={(row) => setSelectedAgingNo(Number(row.seq_No))}
          />
        )}
        {isActiveTab === "packing" && (
          <div className="overflow-x-auto border border-slate-300 rounded-md">
            <table className=" w-full text-[13px]">
              <colgroup>
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
              </colgroup>

              <thead className="bg-slate-50 text-slate-700 sticky top-0 z-10">
                <tr className="text-center text-[12px] font-medium">
                  <th className="border border-slate-200 p-1">BUNDLE NO</th>
                  <th className="border border-slate-200 p-1">DIE NO</th>
                  <th className="border border-slate-200 p-1">SERIES NAME</th>
                  <th className="border border-slate-200 p-1">
                    PROFILE WEIGHT
                  </th>
                  <th className="border border-slate-200 p-1">
                    FINAL CUT LENGHT
                  </th>
                  <th className="border border-slate-200 p-1">UNIT</th>
                  <th className="border border-slate-200 p-1">WT/12 FT</th>
                  <th className="border border-slate-200 p-1">
                    FINAL CUT LENGTH WEIGHT
                  </th>
                  <th className="border border-slate-200 p-1">PCS</th>
                  <th className="border border-slate-200 p-1">TOTAL WEIGHT</th>
                  <th className="border border-slate-200 p-1">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {isPackingData.map((row, idx) => {
                  const isEditingRow = editingKey === row.bundle_No;
                  return (
                    <tr
                      className="hover:bg-slate-50"
                      key={row.bundle_No ?? idx}
                    >
                      <td className="border p-1 text-center">
                        <input
                          value={row.bundle_No}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>
                      <td className="border p-1 text-center">
                        <input
                          value={row.dieNumber}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>
                      <td className="border p-1 text-center">
                        <input
                          value={row.series_Name}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>
                      <td className="border p-1 text-center">
                        <input
                          value={row.profile_Name}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>
                      <td className="border p-1 text-center">
                        <input
                          value={row.wT_Cut_Length}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>
                      <td className="border p-1 text-center">
                        <input
                          value={row.unit_Conv_Name}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>
                      <td className="border p-1 text-center">
                        <input
                          value={row.wT_12_FT}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>
                      <td className="border p-1 text-center">
                        <input
                          value={row.final_CutLength_Weight}
                          disabled
                          className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                        />
                      </td>

                      <td className="border p-1 text-center">
                        {isEditingRow ? (
                          <input
                            value={draft.pcs ?? ""}
                            onChange={(e) =>
                              setDraft((d) => ({ ...d, pcs: e.target.value }))
                            }
                            className="w-full border rounded px-2 py-1 text-right"
                          />
                        ) : (
                          <div className="px-2 py-1 text-right">{row.pcs}</div>
                        )}
                      </td>
                      <td className="border p-1 text-center">
                        {isEditingRow ? (
                          <input
                            value={draft.total_Weight ?? ""}
                            onChange={(e) =>
                              setDraft((d) => ({
                                ...d,
                                total_Weight: e.target.value,
                              }))
                            }
                            className="w-full border rounded px-2 py-1 text-right"
                          />
                        ) : (
                          <div className="px-2 py-1 text-right">
                            {row.total_Weight}
                          </div>
                        )}
                      </td>
                      <td className="border p-1">
                        {!isEditingRow ? (
                          <div className="flex items-center justify-center">
                            <button
                              type="button"
                              className="inline-flex items-center gap-1 px-2 py-1 rounded"
                              onClick={() => handleEdit(row)}
                              disabled={
                                !!editingKey && editingKey !== row.bundle_No
                              }
                            >
                              <MdEdit size={16} />
                            </button>
                          </div>
                        ) : (
                          <div className="flex items-center justify-center gap-2">
                            <button
                              type="button"
                              className="inline-flex items-center gap-1 px-2 py-1 rounded  hover:bg-green-50 text-green-700"
                              onClick={() => handleinlineSave()}
                            >
                              <IoIosSave size={16} />
                            </button>
                            <button
                              type="button"
                              className="inline-flex items-center gap-1 px-2 py-1 rounded hover:bg-rose-50 text-rose-700"
                              onClick={cancelInlineEdit}
                            >
                              <IoCloseSharp size={16} />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {/* <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div> */}
      </div>

      {isModelOpen && formData && (
        <PackingForm
          initialData={selectedPackingData}
          onSave={handleSave}
          onCancel={() => setIsModelOpen(false)}
          isEditing={isEditing}
          filteredData={filteredData}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default Packing;
